import React, {Component} from "react";
import FJPanelAnimation from "../../../common/component/FJPanelAnimation/FJPanelAnimation";
import FJResourcesPhotoTransitionList from "../view/FJResourcesPhotoTransitionList";
import styles from "../view/FJResourcesTransitionList.module.less";
import FJLocalStore from "../../../store/FJLocalStore";
import {FJToolbarAction} from "../../../redux/action/FJRoot.action";
import {connect} from "react-redux";
import {FJPhotoAnimationStore} from "fj-graph";

class FJPhotoAnimationContainer extends Component{

	constructor(props) {
		super(props);
		this.animationList = [
			{
				category: 'photo-animations-title',
				items: [
          {type: '', label: 'none'},
          ...FJPhotoAnimationStore.allAnimation(),
        ],
			}
		]
		this.classes = {
			pageHeaderClasses: {
				listBox: styles.header_list_box,
				seeAllBox:'',
				titleBox: styles.text_animation_box,
				moreBox: '',
			},
			pageHeaderBackClasses: {
				headerBox: '',
				backBox: '',
				titleBox: '',
				backTextBox: ''
			},
			itemClasses: {
        resourceItem: styles.item,
				resourceItemActive: styles.active,
				inner: styles.inner_box,
				addBtnBox: '',
				deleteBtnBox: '',
				addBtn: '',
				name: styles.transition_name,
				link: '',
				refresh: '',
				reloadIcon: ''
			}
		}
		this.resourceViewInfo = {
			width: 140,
			height: 84,
			space: 10,
			marginBottom: 10
		}
		this.config = {
			addIconToolTip: FJLocalStore._('add-to-timeline')
		};
	}

	_render = () => {
    let {isShow, onAddClick, onHandleClick, animationSelected} = this.props;
	  return (
      <FJResourcesPhotoTransitionList classes={this.classes}
                                      isShow={isShow}
                                      allResources={this.animationList}
                                      resourceViewInfo={this.resourceViewInfo}
                                      config={this.config}
                                      onAddClick={onAddClick}
                                      onHandleClick={onHandleClick}
                                      animationSelectedId={animationSelected}
      />
    );
  };

	render() {
		let {isShow, direction} = this.props;
		return (
			<FJPanelAnimation active={isShow} direction={direction} render={this._render} />
		)
	}

}

const mapStateToProps = function (state) {
	return {
		direction: state.resource.direction,
		animationSelected: state.media.animationSelected
	}
}

const mapDispatchToProps = function (dispatch) {
	return {
		onAddClick: function (id, type) {

		},
		onHandleClick: function (id) {
			dispatch(FJToolbarAction.photoAnimationChangeAction(id));
		}
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(FJPhotoAnimationContainer);